// Material Dashboard 3 PRO React Base Styles
import colors from "assets/theme-dark/base/colors";

const { transparent, white } = colors;

const iconButton = {
  styleOverrides: {
    root: {
      "&:hover": {
        backgroundColor: transparent.main,
      },
      backgroundColor: transparent.main,
      color: `${white.main} !important`,
    },
  },
};

export default iconButton;
